import { LanguagesEnv } from "./languagesEnv.enum";

export const environment = {
  production: false,
  qa: true,
  language: LanguagesEnv.Ahumada,
  mock: false,
};
